(() => {
  const roots = document.querySelectorAll('[data-cs-locations-root]');
  if (!roots.length) return;

  const FALLBACKS = {
    'parmer-ranch-porch-pickup': { icon: 'house', color: '#7EA8A6' },
    'parmer-ranch-park': { icon: 'tree', color: '#6F8F6A' },
    'arboretum-farmers-market': { icon: 'tent', color: '#2B3647' },
    'bee-cave-farmers-market': { icon: 'bee', color: '#BE9140' }
  };

  const ICONS = {
    house: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M3 11.2 12 4l9 7.2"/>
        <path d="M5.5 10.5V20h13v-9.5"/>
        <path d="M9.5 20v-5.5h5V20"/>
      </svg>`,
    tree: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M12 21v-6"/>
        <path d="M8.5 21h7"/>
        <path d="M12 3 7.5 10h2.7L6.5 15h11l-3.7-5h2.7L12 3Z"/>
      </svg>`,
    tent: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M3 9h18"/>
        <path d="m5 9 2-5h10l2 5"/>
        <path d="M5 9v11h14V9"/>
        <path d="M9 20v-7h6v7"/>
        <path d="M8 4v5M12 4v5M16 4v5"/>
      </svg>`,
    bee: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M7.4 12.6c0-2.6 2-4.6 4.6-4.6s4.6 2 4.6 4.6-2 4.6-4.6 4.6-4.6-2-4.6-4.6Z"/>
        <path d="M9.2 9.1c-.8-2.1-2.6-3.2-4.2-2.3-1.5.9-.9 3.3 2.4 4.5M14.8 9.1c.8-2.1 2.6-3.2 4.2-2.3 1.5.9.9 3.3-2.4 4.5"/>
        <path d="M9.4 9.1v7M12 8.1v9M14.6 9.1v7"/>
        <path d="M7.4 12.6H4.5M16.6 12.6h2.9"/>
      </svg>`,
    storefront: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M4 9h16l-1.5-5h-13L4 9Z"/>
        <path d="M5 9v11h14V9"/>
        <path d="M8.5 20v-6h7v6"/>
      </svg>`,
    triangle: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M12 4 21 20H3L12 4Z"/>
      </svg>`,
    pin: `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/>
        <circle cx="12" cy="10" r="2.5"/>
      </svg>`
  };

  const MAP_APP_ICONS = {
    google: `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="#4285F4" d="M21.6 12.23c0-.71-.06-1.4-.18-2.06H12v3.9h5.39a4.61 4.61 0 0 1-2 3.03v2.53h3.24c1.9-1.75 2.97-4.34 2.97-7.4Z"/>
        <path fill="#34A853" d="M12 22c2.7 0 4.97-.9 6.63-2.43l-3.24-2.53c-.9.6-2.05.96-3.39.96-2.6 0-4.81-1.76-5.6-4.13H3.06v2.6A10 10 0 0 0 12 22Z"/>
        <path fill="#FBBC05" d="M6.4 13.87A6.02 6.02 0 0 1 6.09 12c0-.65.11-1.28.31-1.87v-2.6H3.06A10 10 0 0 0 2 12c0 1.61.38 3.14 1.06 4.47l3.34-2.6Z"/>
        <path fill="#EA4335" d="M12 6c1.47 0 2.79.51 3.83 1.51l2.87-2.87C16.96 3.02 14.7 2 12 2a10 10 0 0 0-8.94 5.53l3.34 2.6C7.19 7.76 9.4 6 12 6Z"/>
      </svg>`,
    apple: `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="currentColor" d="M15.55 3.15c-.8.05-1.78.55-2.35 1.22-.53.59-.99 1.47-.83 2.32.88.07 1.79-.45 2.34-1.12.55-.66.96-1.53.84-2.42Zm3.35 9.86c-.02-2.48 2.03-3.69 2.12-3.75-1.16-1.7-2.97-1.93-3.62-1.95-1.54-.16-3.01.91-3.79.91-.79 0-2.01-.89-3.3-.86-1.7.02-3.27.99-4.14 2.51-1.76 3.06-.45 7.59 1.27 10.08.84 1.22 1.85 2.58 3.17 2.53 1.27-.05 1.75-.82 3.29-.82 1.53 0 1.96.82 3.31.79 1.37-.02 2.23-1.24 3.07-2.47.97-1.42 1.37-2.79 1.39-2.86-.03-.01-2.74-1.05-2.77-4.11Z"/>
      </svg>`
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const safeColor = (value, fallback = '#2B3647') => {
    const color = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(color) ? color : fallback;
  };

  const fallbackIconForSubtype = (subtype) => {
    const key = normalize(subtype);
    if (key === 'porch_pickup') return 'house';
    if (key === 'neighborhood_park') return 'tree';
    if (key === 'farmers_market') return 'tent';
    return 'pin';
  };

  const iconMarkup = (icon) => ICONS[normalize(icon)] || ICONS.pin;

  const parseJSON = (element) => {
    if (!element) return [];
    try {
      const parsed = JSON.parse(element.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Cold Sugar location identity data could not be parsed.', error);
      return [];
    }
  };

  const createIcon = (className, identity) => {
    const span = document.createElement('span');
    span.className = className;
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = iconMarkup(identity.icon);
    return span;
  };

  roots.forEach((root) => {
    const publicLocations = parseJSON(root.querySelector('[data-cs-location-data]'));
    const configuredIdentities = parseJSON(
      root.querySelector('[data-cs-location-icon-data]') ||
        document.querySelector('[data-cs-location-icon-data]')
    );

    const configuredByHandle = new Map(
      configuredIdentities.map((item) => [normalize(item.handle), item])
    );

    const identityByHandle = new Map();
    const handleByName = new Map();

    publicLocations.forEach((location) => {
      const handle = normalize(location.handle);
      if (!handle) return;

      const configured = configuredByHandle.get(handle) || {};
      const fallback = FALLBACKS[handle] || {};
      const requestedIcon = normalize(configured.icon || location.locationIcon || fallback.icon);
      const icon = ICONS[requestedIcon]
        ? requestedIcon
        : fallbackIconForSubtype(configured.subtype || location.subtype);
      const color = safeColor(
        configured.color || location.markerColor,
        safeColor(fallback.color, '#2B3647')
      );

      const identity = {
        handle,
        name: location.name || configured.name || '',
        icon,
        color
      };

      identityByHandle.set(handle, identity);
      if (identity.name) handleByName.set(normalize(identity.name), handle);
    });

    configuredIdentities.forEach((configured) => {
      const handle = normalize(configured.handle);
      if (!handle || identityByHandle.has(handle)) return;

      const fallback = FALLBACKS[handle] || {};
      const requestedIcon = normalize(configured.icon || fallback.icon);
      const identity = {
        handle,
        name: configured.name || '',
        icon: ICONS[requestedIcon]
          ? requestedIcon
          : fallbackIconForSubtype(configured.subtype),
        color: safeColor(configured.color, safeColor(fallback.color, '#2B3647'))
      };

      identityByHandle.set(handle, identity);
      if (identity.name) handleByName.set(normalize(identity.name), handle);
    });

    const getIdentity = (handle) => {
      const normalizedHandle = normalize(handle);
      return (
        identityByHandle.get(normalizedHandle) || {
          handle: normalizedHandle,
          name: '',
          icon: FALLBACKS[normalizedHandle]?.icon || 'pin',
          color: FALLBACKS[normalizedHandle]?.color || '#2B3647'
        }
      );
    };

    const locationsByHandle = new Map(
      publicLocations.map((location) => [normalize(location.handle), location])
    );

    const PARMER_RANCH_BAKEHOUSE_ADDRESS =
      '2380 Sawdust Dr, Georgetown, TX 78633';

    const FIXED_COORDINATES = {
      'parmer-ranch-porch-pickup': { lat: 30.735764, lng: -97.786975 },
      'parmer-ranch-park': { lat: 30.738026459677197, lng: -97.793715597013 }
    };

    const mapShell = root.querySelector('.cs-map-shell');
    const rankingContainer = root.querySelector('[data-cs-ranking]');
    const nearbyStatus = root.querySelector('[data-cs-nearby-status]');
    const addressInput = root.querySelector('[data-cs-address-input]');
    const findButton = root.querySelector('[data-cs-find-nearby]');
    const localShopUrl = root.dataset.localShopUrl || '/pages/about-us?view=shop&mode=local';

    let frame = null;
    let openPopover = null;
    let openPopoverMarker = null;
    let popoverFrame = null;
    let directionDialog = null;
    let directionDialogTrigger = null;
    let pendingRouteAction = null;
    let routeActionSequence = 0;
    let routeFallbackRunning = false;
    let lastFallbackActionId = 0;

    const escapeHTML = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const getLocation = (handle) => locationsByHandle.get(normalize(handle)) || null;

    const buildLocationOrderUrl = (location) => {
      if (!location?.handle) return localShopUrl;

      if (normalize(location.handle) === 'parmer-ranch-porch-pickup') {
        return '/pages/parmer-ranch-porch-pickup';
      }

      const url = new URL(localShopUrl, window.location.origin);
      const subtype = normalize(
        location.pickupSubtype || location.pickup_subtype || location.subtype
      );

      url.searchParams.set('view', 'shop');
      url.searchParams.set('mode', 'local');
      url.searchParams.set('gateway', 'skip');
      url.searchParams.set(
        'shopping_path',
        subtype === 'bakehouse_order_ahead' ||
          normalize(location.handle) === 'cold-sugar-bakehouse-parmer-ranch'
          ? 'bakehouse_order_ahead'
          : 'market_pickup'
      );
      url.searchParams.set('fulfillment', location.handle);

      return `${url.pathname}${url.search}${url.hash}`;
    };

    const destinationForLocation = (location, coordinates = null) => {
      const normalizedHandle = normalize(location?.handle);

      if (normalizedHandle === 'parmer-ranch-porch-pickup') {
        return PARMER_RANCH_BAKEHOUSE_ADDRESS;
      }

      if (
        coordinates &&
        Number.isFinite(coordinates.lat) &&
        Number.isFinite(coordinates.lng)
      ) {
        return `${coordinates.lat},${coordinates.lng}`;
      }

      const fixed = FIXED_COORDINATES[normalizedHandle];
      if (fixed) return `${fixed.lat},${fixed.lng}`;

      return String(
        location?.mapQuery ||
        location?.publicAddress ||
        location?.cityState ||
        ''
      ).trim();
    };

    const buildGoogleMapsURL = (destination) =>
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
        destination
      )}&travelmode=driving`;

    const buildAppleMapsURL = (destination) =>
      `https://maps.apple.com/?daddr=${encodeURIComponent(destination)}&dirflg=d`;

    const closeDirectionDialog = ({ restoreFocus = true } = {}) => {
      if (!directionDialog) return;
      const dialogToRemove = directionDialog;
      directionDialog = null;
      dialogToRemove.classList.remove('is-open');
      document.body.classList.remove('cs-map-app-dialog-open');

      window.setTimeout(() => dialogToRemove.remove(), 180);

      if (restoreFocus && directionDialogTrigger instanceof HTMLElement) {
        directionDialogTrigger.focus({ preventScroll: true });
      }
      directionDialogTrigger = null;
    };

    const openDirectionChooser = (handle, trigger = null, coordinates = null) => {
      const location = getLocation(handle);
      if (!location) return;

      const isParmerRanchBakehouse =
        normalize(location.handle) ===
        'parmer-ranch-porch-pickup';

      const dialogName = isParmerRanchBakehouse
        ? 'Cold Sugar Bakehouse — Parmer Ranch'
        : location.name;

      const dialogAddress = isParmerRanchBakehouse
        ? PARMER_RANCH_BAKEHOUSE_ADDRESS
        : location.publicAddress || location.cityState || '';

      const destination = destinationForLocation(location, coordinates);
      if (!destination) return;

      closeDirectionDialog({ restoreFocus: false });
      directionDialogTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement;

      const dialog = document.createElement('div');
      dialog.className = 'cs-map-app-dialog';
      dialog.innerHTML = `
        <div class="cs-map-app-dialog__backdrop" data-cs-map-app-close></div>
        <div class="cs-map-app-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="CsMapAppDialogTitle">
          <button type="button" class="cs-map-app-dialog__close" data-cs-map-app-close aria-label="Close directions options">×</button>
          <p class="cs-map-app-dialog__eyebrow">Get directions</p>
          <h2 id="CsMapAppDialogTitle">Open ${escapeHTML(dialogName)} in…</h2>
          <p>${escapeHTML(dialogAddress)}</p>
          <div class="cs-map-app-dialog__choices">
            <a class="cs-map-app-dialog__choice cs-map-app-dialog__choice--google" href="${escapeHTML(
              buildGoogleMapsURL(destination)
            )}" target="_blank" rel="noopener">
              <span class="cs-map-app-dialog__choice-icon" aria-hidden="true">${MAP_APP_ICONS.google}</span>
              <span><strong>Google Maps</strong><small>Open driving directions</small></span>
              <span aria-hidden="true">↗</span>
            </a>
            <a class="cs-map-app-dialog__choice cs-map-app-dialog__choice--apple" href="${escapeHTML(
              buildAppleMapsURL(destination)
            )}" target="_blank" rel="noopener">
              <span class="cs-map-app-dialog__choice-icon" aria-hidden="true">${MAP_APP_ICONS.apple}</span>
              <span><strong>Apple Maps</strong><small>Open driving directions</small></span>
              <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      `;

      document.body.appendChild(dialog);
      directionDialog = dialog;
      document.body.classList.add('cs-map-app-dialog-open');
      requestAnimationFrame(() => dialog.classList.add('is-open'));

      dialog.querySelectorAll('[data-cs-map-app-close]').forEach((button) => {
        button.addEventListener('click', () => closeDirectionDialog());
      });

      dialog.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          window.setTimeout(() => closeDirectionDialog({ restoreFocus: false }), 0);
        });
      });

      const focusable = Array.from(dialog.querySelectorAll('a, button'));
      focusable[0]?.focus();

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDirectionDialog();
          return;
        }

        if (event.key !== 'Tab' || focusable.length < 2) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    };

    const closeMapPopover = () => {
      if (popoverFrame !== null) {
        cancelAnimationFrame(popoverFrame);
        popoverFrame = null;
      }
      openPopover?.remove();
      openPopover = null;
      openPopoverMarker = null;
    };

    const positionMapPopover = () => {
      if (!openPopover || !openPopoverMarker || !mapShell) return;
      if (!document.documentElement.contains(openPopoverMarker)) {
        closeMapPopover();
        return;
      }

      const shellRect = mapShell.getBoundingClientRect();
      const markerRect = openPopoverMarker.getBoundingClientRect();
      const popupRect = openPopover.getBoundingClientRect();
      const gap = 16;
      const margin = 10;

      let left = markerRect.left - shellRect.left + markerRect.width / 2 - popupRect.width / 2;
      left = Math.max(margin, Math.min(left, shellRect.width - popupRect.width - margin));

      let top = markerRect.top - shellRect.top - popupRect.height - gap;
      const below = top < margin;
      if (below) top = markerRect.bottom - shellRect.top + gap;

      openPopover.classList.toggle('is-below', below);
      openPopover.style.left = `${Math.round(left)}px`;
      openPopover.style.top = `${Math.round(top)}px`;
      popoverFrame = requestAnimationFrame(positionMapPopover);
    };

    const showMapPopover = (handle, marker) => {
      const location = getLocation(handle);
      if (!location || !mapShell || !marker) return;

      closeMapPopover();

      const identity = getIdentity(handle);
      const normalizedHandle = normalize(handle);
      const isSharedBakehouse =
        normalizedHandle === 'parmer-ranch-porch-pickup';

      const title = isSharedBakehouse
        ? 'Cold Sugar Bakehouse — Parmer Ranch'
        : location.name;

      const schedule = isSharedBakehouse
        ? 'Order Ahead + Thursday Porch Shop'
        : location.timeWindow || location.displaySchedule || '';

      const address = location.publicAddress || location.cityState || '';

      const standardOrderUrl = buildLocationOrderUrl(location);
      const bakehouseOrderUrl = buildLocationOrderUrl({
        handle: 'cold-sugar-bakehouse-parmer-ranch',
        subtype: 'bakehouse_order_ahead'
      });

      const actionMarkup = isSharedBakehouse
        ? `
          <div class="cs-map-location-popover__actions cs-map-location-popover__actions--shared">
            <a
              href="${escapeHTML(bakehouseOrderUrl)}"
              class="cs-map-location-popover__order"
            >
              Order Ahead
            </a>

            <a
              href="/pages/parmer-ranch-porch-pickup"
              class="cs-map-location-popover__porch"
            >
              Porch Shop
            </a>

            <button
              type="button"
              class="cs-map-location-popover__directions"
              data-cs-map-popover-directions
            >
              Directions
            </button>
          </div>
        `
        : `
          <div class="cs-map-location-popover__actions">
            <a
              href="${escapeHTML(standardOrderUrl)}"
              class="cs-map-location-popover__order"
            >
              Order for pickup
            </a>

            <button
              type="button"
              class="cs-map-location-popover__directions"
              data-cs-map-popover-directions
            >
              Directions
            </button>
          </div>
        `;

      const sharedDetails = isSharedBakehouse
        ? `
          <div class="cs-map-location-popover__shared-options">
            <div>
              <strong>Order Ahead</strong>
              <span>Full menu · Pickup · 48+ hours ahead</span>
            </div>

            <div>
              <strong>Thursday Porch Shop</strong>
              <span>Limited live menu · Thursdays from 3–7 PM</span>
            </div>
          </div>
        `
        : '';

      const popup = document.createElement('section');
      popup.className = `cs-map-location-popover${
        isSharedBakehouse ? ' is-shared' : ''
      }`;
      popup.style.setProperty('--cs-location-color', identity.color);
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-label', `${title} map details`);

      popup.innerHTML = `
        <span class="cs-map-location-popover__arrow" aria-hidden="true"></span>

        <button
          type="button"
          class="cs-map-location-popover__close"
          data-cs-map-popover-close
          aria-label="Close location details"
        >
          ×
        </button>

        <div class="cs-map-location-popover__heading">
          <span class="cs-map-location-popover__icon" aria-hidden="true">
            ${iconMarkup(identity.icon)}
          </span>

          <span>
            <strong>${escapeHTML(title)}</strong>
            ${schedule ? `<small>${escapeHTML(schedule)}</small>` : ''}
          </span>
        </div>

        <p class="cs-map-location-popover__address">
          ${escapeHTML(address)}
        </p>

        ${sharedDetails}
        ${actionMarkup}
      `;

      mapShell.appendChild(popup);
      openPopover = popup;
      openPopoverMarker = marker;

      popup
        .querySelector('[data-cs-map-popover-close]')
        ?.addEventListener('click', closeMapPopover);

      popup
        .querySelector('[data-cs-map-popover-directions]')
        ?.addEventListener('click', (event) => {
          openDirectionChooser(handle, event.currentTarget);
        });

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMapPopover();
      });

      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        positionMapPopover();
      });
    };

    const decorate = () => {
      frame = null;

      root.querySelectorAll('[data-schedule-handle]').forEach((card) => {
        const identity = getIdentity(card.dataset.scheduleHandle);
        card.style.setProperty('--cs-location-color', identity.color);

        if (!card.querySelector('.cs-location-identity__schedule-icon')) {
          const icon = createIcon('cs-location-identity__schedule-icon', identity);
          const date = card.querySelector('.cs-schedule-card__date');
          if (date) date.insertAdjacentElement('afterend', icon);
        }
      });

      root.querySelectorAll('[data-drawer-handle]').forEach((event) => {
        const identity = getIdentity(event.dataset.drawerHandle);
        event.style.setProperty('--cs-location-color', identity.color);

        if (!event.querySelector('.cs-location-identity__drawer-icon')) {
          event.prepend(createIcon('cs-location-identity__drawer-icon', identity));
        }
      });

      root.querySelectorAll('[data-rank-handle]').forEach((card) => {
        const identity = getIdentity(card.dataset.rankHandle);
        card.style.setProperty('--cs-location-color', identity.color);
        card.querySelectorAll('.cs-rank-card__number').forEach((number) => number.remove());

        if (normalize(card.dataset.rankHandle) === 'parmer-ranch-porch-pickup') {
          const title = card.querySelector('h3');
          const schedule = card.querySelector('p');

          if (title) title.textContent = 'Cold Sugar Bakehouse — Parmer Ranch';
          if (schedule) schedule.textContent = 'Order Ahead + Thursday Porch Shop';
        }

        if (!card.querySelector('.cs-location-identity__rank-icon')) {
          card.prepend(createIcon('cs-location-identity__rank-icon', identity));
        }
      });

      root.querySelectorAll('[data-cs-location-card][data-location-handle]').forEach((card) => {
        const identity = getIdentity(card.dataset.locationHandle);
        card.style.setProperty('--cs-location-color', identity.color);

        if (!card.querySelector('.cs-location-identity__profile-icon')) {
          const icon = createIcon('cs-location-identity__profile-icon', identity);
          const mediaCopy = card.querySelector('.cs-location-card__media-copy');
          if (mediaCopy) mediaCopy.prepend(icon);
          else card.prepend(icon);
        }
      });

      root.querySelectorAll('.cs-google-marker:not(.cs-google-marker--origin)').forEach((marker) => {
        const label = normalize(
          marker.getAttribute('title') ||
            String(marker.getAttribute('aria-label') || '').replace(/^show\s+/i, '')
        );
        const handle = handleByName.get(label);
        if (!handle) return;

        const identity = getIdentity(handle);
        marker.style.setProperty('--cs-marker-color', identity.color);
        marker.dataset.locationHandle = identity.handle;
        marker.querySelectorAll('.cs-google-marker__number').forEach((number) => number.remove());

        if (identity.handle === 'parmer-ranch-porch-pickup') {
          marker.title = 'Cold Sugar Bakehouse — Parmer Ranch';
          marker.setAttribute(
            'aria-label',
            'Show Cold Sugar Bakehouse — Parmer Ranch'
          );
        }

        if (!marker.querySelector('.cs-google-marker__icon')) {
          marker.append(createIcon('cs-google-marker__icon', identity));
        }
      });
    };

    const scheduleDecorate = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(decorate);
    };

    const observer = new MutationObserver(scheduleDecorate);
    observer.observe(root, { childList: true, subtree: true });

    const findMarkerForHandle = (handle) => {
      decorate();
      return Array.from(
        root.querySelectorAll('.cs-google-marker:not(.cs-google-marker--origin)')
      ).find((item) => normalize(item.dataset.locationHandle) === normalize(handle));
    };

    // Capture the customer's requested origin before the original map script starts
    // its asynchronous geocoding and route comparison.
    root.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('[data-cs-find-nearby]')) {
          pendingRouteAction = {
            id: ++routeActionSequence,
            type: 'address',
            address: addressInput?.value.trim() || ''
          };
        } else if (event.target.closest('[data-cs-use-location]')) {
          pendingRouteAction = {
            id: ++routeActionSequence,
            type: 'geolocation'
          };
        }
      },
      true
    );

    // Use one shared interaction path for card -> marker and marker -> popup.
    root.addEventListener('click', (event) => {
      const directionsLink = event.target.closest('a');
      if (directionsLink && root.contains(directionsLink)) {
        const card = directionsLink.closest(
          '[data-schedule-handle], [data-cs-location-card][data-location-handle]'
        );
        const looksLikeDirections =
          /directions/i.test(directionsLink.textContent || '') ||
          /google\.[^/]+\/maps|maps\.google|maps\.apple/i.test(directionsLink.href || '');

        if (card && looksLikeDirections) {
          const handle =
            card.dataset.scheduleHandle ||
            card.dataset.locationHandle;

          event.preventDefault();
          openDirectionChooser(handle, directionsLink);
          return;
        }
      }

      const marker = event.target.closest('.cs-google-marker:not(.cs-google-marker--origin)');
      if (marker && root.contains(marker)) {
        const handle = normalize(marker.dataset.locationHandle);
        if (handle) showMapPopover(handle, marker);
        return;
      }

      const card = event.target.closest('[data-rank-handle]');
      if (!card || !root.contains(card)) return;

      const markerForCard = findMarkerForHandle(card.dataset.rankHandle);
      if (markerForCard) markerForCard.click();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && openPopover) closeMapPopover();
    });

    const waitForGoogleMaps = async (timeoutMs = 10000) => {
      const start = Date.now();
      while (!window.google?.maps?.importLibrary) {
        if (Date.now() - start > timeoutMs) throw new Error('GOOGLE_MAPS_NOT_READY');
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }
      return window.google.maps;
    };

    const initValidatedAddressAutocomplete = async () => {
      if (!addressInput || !findButton) return;

      const searchRow = addressInput.closest('.cs-nearby__search-row');
      if (!searchRow || searchRow.querySelector('[data-cs-address-autocomplete-data]')) return;

      try {
        await waitForGoogleMaps();
        const { AutocompleteSessionToken, AutocompleteSuggestion } =
          await google.maps.importLibrary('places');

        if (!AutocompleteSessionToken || !AutocompleteSuggestion) {
          throw new Error('PLACES_AUTOCOMPLETE_DATA_UNAVAILABLE');
        }

        // Remove the prior self-contained widget if this section was hot-reloaded
        // in the Shopify editor, then restore the theme's original address input.
        const oldWrapper = searchRow.querySelector('.cs-address-autocomplete-wrap');
        if (oldWrapper) {
          oldWrapper.parentNode?.insertBefore(addressInput, oldWrapper);
          oldWrapper.remove();
        }

        addressInput.classList.remove('cs-address-input--enhanced');
        addressInput.removeAttribute('aria-hidden');
        addressInput.removeAttribute('tabindex');
        addressInput.autocomplete = 'off';
        addressInput.spellcheck = false;

        const wrapper = document.createElement('div');
        wrapper.className = 'cs-address-suggest';
        wrapper.dataset.csAddressAutocompleteData = '';

        const listId = `CsAddressSuggestions-${Math.random().toString(36).slice(2, 9)}`;
        const list = document.createElement('div');
        list.id = listId;
        list.className = 'cs-address-suggest__list';
        list.setAttribute('role', 'listbox');
        list.hidden = true;

        const helper = document.createElement('span');
        helper.className = 'cs-address-suggest__helper';
        helper.textContent = 'Start typing your street address.';
        helper.setAttribute('aria-live', 'polite');

        searchRow.insertBefore(wrapper, addressInput);
        wrapper.append(addressInput, list, helper);

        addressInput.setAttribute('role', 'combobox');
        addressInput.setAttribute('aria-autocomplete', 'list');
        addressInput.setAttribute('aria-controls', listId);
        addressInput.setAttribute('aria-expanded', 'false');

        let sessionToken = null;
        let suggestions = [];
        let activeIndex = -1;
        let debounceTimer = 0;
        let requestSequence = 0;
        let selectionInProgress = false;

        const isDirectZip = (value) => /^\d{5}(?:-\d{4})?$/.test(String(value || '').trim());

        const setExpanded = (expanded) => {
          addressInput.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          list.hidden = !expanded;
          wrapper.classList.toggle('is-open', expanded);
        };

        const hideSuggestions = () => {
          activeIndex = -1;
          list.querySelectorAll('[role="option"]').forEach((option) => {
            option.classList.remove('is-active');
            option.setAttribute('aria-selected', 'false');
          });
          addressInput.removeAttribute('aria-activedescendant');
          setExpanded(false);
        };

        const clearValidatedSelection = ({ keepHelper = false } = {}) => {
          delete addressInput.dataset.csValidatedAddress;
          delete addressInput.dataset.csSelectedLat;
          delete addressInput.dataset.csSelectedLng;
          wrapper.classList.remove('is-verified');
          if (!keepHelper) helper.textContent = 'Choose one of the suggested addresses.';
        };

        const renderSuggestions = (nextSuggestions) => {
          suggestions = nextSuggestions
            .filter((item) => item?.placePrediction)
            .slice(0, 6);
          activeIndex = -1;
          list.innerHTML = '';

          if (!suggestions.length) {
            helper.textContent = 'No matching addresses found. Keep typing or try a ZIP code.';
            hideSuggestions();
            return;
          }

          suggestions.forEach((suggestion, index) => {
            const prediction = suggestion.placePrediction;
            const fullText = prediction.text?.toString?.() || '';
            const mainText = prediction.mainText?.toString?.() || fullText;
            const secondaryText = prediction.secondaryText?.toString?.() || '';

            const button = document.createElement('button');
            button.type = 'button';
            button.id = `${listId}-option-${index}`;
            button.className = 'cs-address-suggest__option';
            button.setAttribute('role', 'option');
            button.setAttribute('aria-selected', 'false');
            button.dataset.suggestionIndex = String(index);
            button.innerHTML = `
              <span class="cs-address-suggest__pin" aria-hidden="true">⌖</span>
              <span class="cs-address-suggest__copy">
                <strong>${escapeHTML(mainText)}</strong>
                ${secondaryText && secondaryText !== mainText ? `<small>${escapeHTML(secondaryText)}</small>` : ''}
              </span>
            `;

            button.addEventListener('mousedown', (event) => event.preventDefault());
            button.addEventListener('click', () => void selectSuggestion(index));
            list.appendChild(button);
          });

          const attribution = document.createElement('div');
          attribution.className = 'cs-address-suggest__attribution';
          attribution.textContent = 'Powered by Google';
          list.appendChild(attribution);

          helper.textContent = 'Choose a suggested address.';
          setExpanded(true);
        };

        const updateActiveOption = (nextIndex) => {
          if (!suggestions.length) return;
          activeIndex = (nextIndex + suggestions.length) % suggestions.length;

          list.querySelectorAll('[role="option"]').forEach((option, index) => {
            const active = index === activeIndex;
            option.classList.toggle('is-active', active);
            option.setAttribute('aria-selected', active ? 'true' : 'false');
            if (active) {
              addressInput.setAttribute('aria-activedescendant', option.id);
              option.scrollIntoView({ block: 'nearest' });
            }
          });
        };

        const selectSuggestion = async (index) => {
          const prediction = suggestions[index]?.placePrediction;
          if (!prediction) return;

          selectionInProgress = true;
          wrapper.classList.add('is-loading');
          helper.textContent = 'Confirming address…';
          hideSuggestions();

          try {
            const place = prediction.toPlace();
            await place.fetchFields({
              fields: ['displayName', 'formattedAddress', 'location']
            });

            const formattedAddress = String(
              place.formattedAddress || prediction.text?.toString?.() || ''
            ).trim();

            if (!formattedAddress) throw new Error('PLACE_ADDRESS_UNAVAILABLE');

            addressInput.value = formattedAddress;
            addressInput.dataset.csValidatedAddress = 'true';

            if (place.location) {
              addressInput.dataset.csSelectedLat = String(place.location.lat());
              addressInput.dataset.csSelectedLng = String(place.location.lng());
            }

            wrapper.classList.add('is-verified');
            helper.textContent = 'Address selected — finding nearby locations…';
            sessionToken = null;
            suggestions = [];

            if (nearbyStatus) {
              nearbyStatus.textContent =
                `Selected ${formattedAddress}. Comparing drive times…`;
            }

            // Reuse the existing Find nearby interaction so address selection,
            // route comparison, map movement, and fallback handling stay in sync.
            window.requestAnimationFrame(() => {
              findButton.click();
            });
          } catch (error) {
            clearValidatedSelection();
            console.warn('Cold Sugar address suggestion could not be confirmed.', error);
            helper.textContent = 'That address could not be confirmed. Please choose another suggestion.';
            if (nearbyStatus) {
              nearbyStatus.textContent =
                'We could not confirm that suggestion. Please choose another address.';
            }
          } finally {
            wrapper.classList.remove('is-loading');
            window.setTimeout(() => {
              selectionInProgress = false;
            }, 0);
          }
        };

        const requestSuggestions = async () => {
          const query = addressInput.value.trim();
          const requestId = ++requestSequence;

          if (query.length < 3) {
            suggestions = [];
            hideSuggestions();
            helper.textContent = query
              ? 'Keep typing to see matching addresses.'
              : 'Start typing your street address.';
            return;
          }

          if (!sessionToken) sessionToken = new AutocompleteSessionToken();
          wrapper.classList.add('is-loading');
          helper.textContent = 'Finding matching addresses…';

          try {
            const { suggestions: nextSuggestions = [] } =
              await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                input: query,
                includedRegionCodes: ['us'],
                language: 'en-US',
                region: 'us',
                locationBias: {
                  center: { lat: 30.45, lng: -97.75 },
                  radius: 50000
                },
                sessionToken
              });

            if (requestId !== requestSequence || addressInput.value.trim() !== query) return;
            renderSuggestions(nextSuggestions);
          } catch (error) {
            if (requestId !== requestSequence) return;
            suggestions = [];
            hideSuggestions();
            helper.textContent = isDirectZip(query)
              ? 'ZIP codes can still be searched directly.'
              : 'Address suggestions are unavailable right now. You can still enter the full address.';
            console.warn(
              'Cold Sugar address suggestions failed. Confirm Places API (New) is enabled and allowed on the browser key.',
              error
            );
          } finally {
            if (requestId === requestSequence) wrapper.classList.remove('is-loading');
          }
        };

        addressInput.addEventListener('input', () => {
          if (!selectionInProgress) clearValidatedSelection({ keepHelper: true });
          window.clearTimeout(debounceTimer);
          debounceTimer = window.setTimeout(() => void requestSuggestions(), 220);
        });

        addressInput.addEventListener('focus', () => {
          if (suggestions.length && !addressInput.dataset.csValidatedAddress) {
            setExpanded(true);
          }
        });

        addressInput.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            if (!list.hidden && suggestions.length) {
              event.preventDefault();
              updateActiveOption(activeIndex + 1);
            }
            return;
          }

          if (event.key === 'ArrowUp') {
            if (!list.hidden && suggestions.length) {
              event.preventDefault();
              updateActiveOption(activeIndex - 1);
            }
            return;
          }

          if (event.key === 'Enter' && !list.hidden && activeIndex >= 0) {
            event.preventDefault();
            void selectSuggestion(activeIndex);
            return;
          }

          if (event.key === 'Escape') hideSuggestions();
        });

        document.addEventListener('click', (event) => {
          if (!wrapper.contains(event.target)) hideSuggestions();
        });

        findButton.addEventListener(
          'click',
          (event) => {
            const value = addressInput.value.trim();
            const validSelection = addressInput.dataset.csValidatedAddress === 'true';

            if (!value || validSelection || isDirectZip(value)) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            pendingRouteAction = null;
            helper.textContent = 'Choose a suggested address before comparing routes.';
            if (nearbyStatus) {
              nearbyStatus.textContent =
                'Please choose one of the suggested addresses, or enter a 5-digit ZIP code.';
            }
            addressInput.focus();
            if (suggestions.length) setExpanded(true);
          },
          true
        );
      } catch (error) {
        console.warn(
          'Cold Sugar address autocomplete is unavailable; keeping the standard address field.',
          error
        );
      }
    };

    const geocodeAddress = async (address) => {
      await waitForGoogleMaps();
      const geocoder = new google.maps.Geocoder();
      const response = await geocoder.geocode({
        address,
        region: 'us',
        componentRestrictions: { country: 'US' }
      });
      const result = response.results?.[0];
      if (!result) throw new Error('ADDRESS_NOT_FOUND');
      return {
        coordinates: {
          lat: result.geometry.location.lat(),
          lng: result.geometry.location.lng()
        },
        label: result.formatted_address || address
      };
    };

    const getCurrentCoordinates = () =>
      new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error('GEOLOCATION_NOT_SUPPORTED'));
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (position) =>
            resolve({
              coordinates: {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              },
              label: 'your current location'
            }),
          () => reject(new Error('GEOLOCATION_DENIED')),
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      });

    const getDestinationCoordinates = async (location) => {
      const handle = normalize(location.handle);
      if (FIXED_COORDINATES[handle]) return FIXED_COORDINATES[handle];

      const latitude = Number(location.latitude ?? location.mapLatitude);
      const longitude = Number(location.longitude ?? location.mapLongitude);
      if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
        return { lat: latitude, lng: longitude };
      }

      const query = String(location.mapQuery || location.publicAddress || '').trim();
      if (!query) return null;

      const cacheKey = `csGeocode:${query}`;
      try {
        const cached = JSON.parse(window.localStorage.getItem(cacheKey) || 'null');
        if (Number.isFinite(cached?.lat) && Number.isFinite(cached?.lng)) return cached;
      } catch (_error) {
        // Ignore invalid cached coordinates.
      }

      const result = await geocodeAddress(query);
      try {
        window.localStorage.setItem(cacheKey, JSON.stringify(result.coordinates));
      } catch (_error) {
        // Local storage may be unavailable in private browsing.
      }
      return result.coordinates;
    };

    const normalizeRouteMatrixItems = (response, destinations) => {
      const items = response?.matrix?.rows?.[0]?.items || [];
      return destinations
        .map(({ location }, index) => {
          const item = items[index];
          const condition = String(item?.condition || 'ROUTE_EXISTS');
          const routeExists = !condition || condition === 'ROUTE_EXISTS';
          const durationMillis = Number(item?.durationMillis);
          const distanceMeters = Number(item?.distanceMeters);
          if (!routeExists || !Number.isFinite(durationMillis) || !Number.isFinite(distanceMeters)) {
            return null;
          }
          return { location, durationMillis, distanceMeters };
        })
        .filter(Boolean);
    };

    const routesWithMatrix = async (origin, destinations) => {
      const [routesLibrary, coreLibrary] = await Promise.all([
        google.maps.importLibrary('routes'),
        google.maps.importLibrary('core')
      ]);
      if (!routesLibrary.RouteMatrix?.computeRouteMatrix) throw new Error('ROUTE_MATRIX_UNAVAILABLE');

      const response = await routesLibrary.RouteMatrix.computeRouteMatrix({
        origins: [origin],
        destinations: destinations.map((item) => item.coordinates),
        travelMode: 'DRIVING',
        routingPreference: 'TRAFFIC_UNAWARE',
        units: coreLibrary.UnitSystem?.IMPERIAL || 'IMPERIAL',
        fields: ['durationMillis', 'distanceMeters', 'condition']
      });

      const results = normalizeRouteMatrixItems(response, destinations);
      if (!results.length) throw new Error('NO_MATRIX_ROUTES');
      return results;
    };

    const routesIndividually = async (origin, destinations) => {
      const routesLibrary = await google.maps.importLibrary('routes');
      if (!routesLibrary.Route?.computeRoutes) throw new Error('ROUTE_CLASS_UNAVAILABLE');

      const results = await Promise.all(
        destinations.map(async ({ location, coordinates }) => {
          try {
            const response = await routesLibrary.Route.computeRoutes({
              origin,
              destination: coordinates,
              travelMode: 'DRIVING',
              routingPreference: 'TRAFFIC_UNAWARE',
              fields: ['distanceMeters', 'durationMillis']
            });
            const route = response.routes?.[0];
            const durationMillis = Number(route?.durationMillis);
            const distanceMeters = Number(route?.distanceMeters);
            if (!Number.isFinite(durationMillis) || !Number.isFinite(distanceMeters)) return null;
            return { location, durationMillis, distanceMeters };
          } catch (error) {
            console.warn(`Fallback directions unavailable for ${location.name}.`, error);
            return null;
          }
        })
      );

      return results.filter(Boolean);
    };

    const renderFallbackRankings = (ranked, originLabel) => {
      if (!rankingContainer) return;

      const sorted = [...ranked].sort((a, b) => a.durationMillis - b.durationMillis);
      rankingContainer.innerHTML = sorted
        .map(({ location, durationMillis, distanceMeters }, index) => {
          const minutes = Math.max(1, Math.round(durationMillis / 60000));
          const miles = distanceMeters / 1609.344;
          const identity = getIdentity(location.handle);
          return `
            <button type="button" class="cs-rank-card${index === 0 ? ' is-active' : ''}" data-rank-handle="${escapeHTML(
              location.handle
            )}" style="--cs-location-color:${escapeHTML(identity.color)}">
              <span>
                <h3>${escapeHTML(location.name)}</h3>
                <p>${escapeHTML(location.displaySchedule || location.timeWindow || '')}</p>
              </span>
              <span class="cs-rank-card__distance">
                <strong>${minutes} min</strong>
                <span>${miles.toFixed(miles < 10 ? 1 : 0)} miles</span>
              </span>
            </button>
          `;
        })
        .join('');

      decorate();
      const closest = sorted[0]?.location;
      if (closest) {
        const marker = findMarkerForHandle(closest.handle);
        marker?.click();
      }

      if (nearbyStatus && closest) {
        nearbyStatus.textContent = `${closest.name} is the closest Cold Sugar stop from ${originLabel}.`;
      }
    };

    const runRouteFallback = async (action) => {
      if (!action || routeFallbackRunning || action.id === lastFallbackActionId) return;
      routeFallbackRunning = true;
      lastFallbackActionId = action.id;

      try {
        if (nearbyStatus) nearbyStatus.textContent = 'Retrying the drive-time comparison…';
        await waitForGoogleMaps();

        const originResult =
          action.type === 'address'
            ? await geocodeAddress(action.address)
            : await getCurrentCoordinates();

        const destinationPairs = (
          await Promise.all(
            publicLocations
              .filter((location) => location.mapEnabled && normalize(location.category) === 'pickup')
              .map(async (location) => ({
                location,
                coordinates: await getDestinationCoordinates(location)
              }))
          )
        ).filter((item) => item.coordinates);

        if (!destinationPairs.length) throw new Error('NO_DESTINATIONS');

        let ranked;
        try {
          ranked = await routesWithMatrix(originResult.coordinates, destinationPairs);
        } catch (matrixError) {
          console.warn('Cold Sugar route-matrix retry failed; trying individual routes.', matrixError);
          ranked = await routesIndividually(originResult.coordinates, destinationPairs);
        }

        if (!ranked.length) throw new Error('NO_ROUTES_FOUND');
        renderFallbackRankings(ranked, originResult.label);
      } catch (error) {
        console.error('Cold Sugar route comparison fallback failed.', error);
        if (nearbyStatus) {
          nearbyStatus.textContent =
            'We found your location, but Google’s route comparison is temporarily unavailable. You can still open directions from any location.';
        }
      } finally {
        routeFallbackRunning = false;
      }
    };

    const routeFailurePattern =
      /couldn[’']t compare the driving routes|couldn[’']t calculate driving routes|drive-time comparison could not finish/i;

    if (nearbyStatus) {
      const statusObserver = new MutationObserver(() => {
        const statusText = nearbyStatus.textContent || '';
        if (routeFailurePattern.test(statusText) && pendingRouteAction) {
          void runRouteFallback({ ...pendingRouteAction });
        }
      });
      statusObserver.observe(nearbyStatus, { childList: true, characterData: true, subtree: true });
    }

    void initValidatedAddressAutocomplete();
    decorate();
  });
})();